module.exports = __webpack_public_path__ + "static/media/small_loader.be0d9fd5.gif";